import { User } from 'firebase/auth';

import { SocialLoginMethod } from '@mopla/constants';

export interface ISocialLoginResult {
	user: User | null;
	providerId?: string;
}

export type TPushEvent = (
	event: 'login_attempt' | 'login' | 'sign_up_attempt' | 'sign_up',
	method: 'email' | 'google' | 'apple' | 'facebook'
) => void;

export type TSocialLoginMethod = SocialLoginMethod;

export enum SocialProviderEnum {
	APPLE = 'apple.com',
	GOOGLE = 'google.com',
	FACEBOOK = 'facebook.com',
}

export enum SocialLoginErrorCodeEnum {
	LOGIN_FAILED = 'LOGIN_FAILED',
	GOOGLE_ADD_ACCOUNT = 'GOOGLE_ADD_ACCOUNT',
	DIFFERENT_CREDENTIAL_EXISTS = 'DIFFERENT_CREDENTIAL_EXISTS',
	USER_NOT_FOUND = 'USER_NOT_FOUND',
}

export interface IPendingCredential {
	providerId: string;
	token: string;
	email?: string;
}

export interface IPendingCredentialStore {
	pendingCredential: IPendingCredential;
	setPendingCredential: (pendingCredential: IPendingCredential) => void;
	resetPendingCredential: () => void;
}
